export default "__VITE_PUBLIC_ASSET__11f6c6f3__"